function formatToCurrency(value) {
  const parsedValue = parseFloat((Math.round(value * 100) / 100).toFixed(2));
  if (Number.isNaN(parsedValue)) {
    return ''; 
  }
  return parsedValue.toFixed(2);
 }

module.exports = {
  formatToCurrency,
};